export default __webpack_public_path__ + "static/media/03.84902ef0.jpg";